import { render, staticRenderFns } from "./StuhrEye.vue?vue&type=template&id=fb0f566e&scoped=true&"
import script from "./StuhrEye.vue?vue&type=script&lang=js&"
export * from "./StuhrEye.vue?vue&type=script&lang=js&"
import style0 from "./StuhrEye.vue?vue&type=style&index=0&id=fb0f566e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0f566e",
  null
  
)

export default component.exports